import type { Ruolo } from '@aulaviva/shared';
import { Alert, Button, Logo, PageHeading } from '@aulaviva/ui';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';
import { ErroreRichiesta } from '@/api/client';
import { homePerRuolo } from '@/lib/ruoli';
import { comuni, nonAutorizzata, nonTrovata } from '@/testi';

/** Errore non gestito di una rotta (API irraggiungibile, 5xx): spiega e offre di riprovare. */
export function ErrorePagina() {
  const errore = useRouteError();
  const navigate = useNavigate();
  if (isRouteErrorResponse(errore) && errore.status === 403) {
    const d = (errore.data ?? {}) as { area?: Ruolo; ruolo?: Ruolo };
    const testo = nonAutorizzata[d.area ?? 'admin'];
    return (
      <main className="min-h-dvh contenitore flex flex-col items-center justify-center gap-8 text-center">
        <Logo variant="marchio" height={64} className="dark:hidden" />
        <Logo variant="marchio-negativo" height={64} className="hidden dark:block" decorative />
        <PageHeading subtitle={testo}>{nonAutorizzata.titolo}</PageHeading>
        <Button variant="primary" onClick={() => navigate(homePerRuolo(d.ruolo ?? 'partecipante'))}>
          {nonAutorizzata.azione}
        </Button>
      </main>
    );
  }
  const messaggio =
    errore instanceof ErroreRichiesta
      ? errore.codice === 'rete'
        ? comuni.erroreRete
        : errore.message
      : isRouteErrorResponse(errore) && errore.status === 404
        ? nonTrovata.testo
        : comuni.erroreGenerico;
  return (
    <main className="min-h-dvh contenitore flex flex-col items-center justify-center gap-8">
      <Logo variant="marchio" height={64} className="dark:hidden" />
      <Logo variant="marchio-negativo" height={64} className="hidden dark:block" decorative />
      <div className="w-full max-w-[480px] flex flex-col gap-6">
        <Alert variant="error" title={messaggio} action={<Button variant="primary" onClick={() => window.location.reload()}>{comuni.riprova}</Button>} />
      </div>
    </main>
  );
}
